import { render, staticRenderFns } from "./MessageItem.vue?vue&type=template&id=ecca49d2&scoped=true&"
import script from "./MessageItem.vue?vue&type=script&lang=js&"
export * from "./MessageItem.vue?vue&type=script&lang=js&"
import style0 from "./MessageItem.vue?vue&type=style&index=0&id=ecca49d2&prod&lang=scss&scoped=true&"
import style1 from "./MessageItem.vue?vue&type=style&index=1&id=ecca49d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecca49d2",
  null
  
)

export default component.exports